import React, { useState } from "react";
import { Calendar } from "lucide-react";

export const PRESETS = [
  { id: "today", label: "היום" },
  { id: "7d", label: "7 ימים אחרונים" },
  { id: "30d", label: "30 ימים אחרונים" },
  { id: "month", label: "החודש הנוכחי" },
  { id: "year", label: "השנה הנוכחית" },
  { id: "custom", label: "טווח מותאם" },
];

/** value: { preset, from, to } — `from`/`to` are ISO date strings, only
 * meaningful when preset === 'custom'. */
const DateRangeFilter = ({ value, onChange }) => {
  const [customOpen, setCustomOpen] = useState(false);

  const selectPreset = (id) => {
    if (id === "custom") {
      setCustomOpen(true);
      onChange({ ...value, preset: "custom" });
    } else {
      setCustomOpen(false);
      onChange({ preset: id, from: null, to: null });
    }
  };

  return (
    <div className="relative">
      <div className="inline-flex flex-wrap items-center gap-1 bg-gray-100 rounded-xl p-1">
        {PRESETS.map((p) => (
          <button
            key={p.id}
            onClick={() => selectPreset(p.id)}
            className={`px-2.5 py-1.5 rounded-lg text-[11px] font-bold transition whitespace-nowrap ${
              value.preset === p.id
                ? "bg-white text-indigo-700 shadow-sm"
                : "text-gray-500 hover:text-gray-700 hover:bg-white/60"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      {customOpen && value.preset === "custom" && (
        <div className="absolute left-0 mt-2 z-20 bg-white rounded-xl shadow-xl ring-1 ring-black/5 p-3 flex items-center gap-2">
          <Calendar className="w-4 h-4 text-gray-400" />
          <input
            type="date"
            value={value.from || ""}
            onChange={(e) => onChange({ ...value, from: e.target.value })}
            className="text-xs border border-gray-200 rounded-lg px-2 py-1.5"
          />
          <span className="text-xs text-gray-400">עד</span>
          <input
            type="date"
            value={value.to || ""}
            onChange={(e) => onChange({ ...value, to: e.target.value })}
            className="text-xs border border-gray-200 rounded-lg px-2 py-1.5"
          />
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;